export default __webpack_public_path__ + "646a04a84caea27d5c92ae039c5ffd36.svg";